import React from "react";
import {Dot} from "#app/pages/IncomeAndExpenses/components/BaseOperationList/style";
import {ActiveConstants} from "finhelper";

export const RelationSumDisplay = ({ item, handleDetach }) => {
    const isCreditOrObligation = [
        ...ActiveConstants.CREDIT_GROUP,
        ActiveConstants.CUSTOM_OBLIGATION
    ].includes(item.type_id);

    return (
        <>
            {item.relation_sum > 0 && (
                <Dot
                    id={`operation-dot-${item.id}`}
                    onClick={isCreditOrObligation ? undefined : handleDetach}
                    data-tooltip-content={
                        isCreditOrObligation
                            ? "Связанное обязательство"
                            : "Отвязать расход"
                    }
                    style={isCreditOrObligation ? { cursor: "default" } : {}}
                />
            )}
        </>
    );
};